import { InjectionToken } from '@angular/core';

import { WebVitalsConfig } from '../models/web-vitals-config.model';

export const WEB_VITALS_CONFIG = new InjectionToken<WebVitalsConfig>(
  'WebVitalsConfigToken',
);
